import Images from 'config/assets';
import Device from 'constants/deviceSizes';
import { appConfig } from 'config/customization';

export default {
  container: {
    width: '100%',
    minHeight: '100%',
    backgroundImage: `url(${Images.publicHomeBackground})`,
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    display: 'flex',
    flexDirection: appConfig.publicHomeWithLogo ? 'column' : 'row',
    padding: appConfig.publicHomeWithLogo ? 40 : 0,
    boxSizing: 'border-box',
    alignItems: 'center',
    [Device.mobile]: {
      background: 'none'
    }
  },
  textContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: !appConfig.publicHomeWithLogo && '30%',
    marginLeft: 35,
    height: '100%',
    justifyContent: 'center',
    [Device.mobile]: {
      width: '100%',
      paddingLeft: 20,
      paddingRight: 20,
      marginLeft: 0,
      alignItems: 'left'
    }
  },
  subtitle: {
    width: '90%',
    marginTop: 10,
    marginBottom: 25,
    lineHeight: 1.5,
    textAlign: 'left',
    [Device.mobile]: {
      textAlign: 'left'
    }
  },
  list: {
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'left',
    [Device.mobile]: {
      textAlign: 'left'
    }
  },
  listItem: {
    marginBottom: 10,
    lineHeight: 1.5
  },
  utilityLogo: {
    alignSelf: 'center',
    height: 'auto',
    width: 90,
    display: 'none',
    [Device.mobile]: {
      display: 'flex',
      marginBottom: 15
    }
  },
  fullLogo: {
    height: 'auto',
    maxWidth: '100%',
    width: 350,
    marginBottom: 40
  }
};
